function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F9F9F",
  fillRule: "evenodd",
  d: "M17.5 18V3H2.5V18L6.20911 16L10.0135 18L13.9968 16L17.5 18ZM10.1899 13.5142V14.1776H9.44851V13.5247C7.79097 13.4306 6.79009 12.6053 6.78479 11.3308H8.29935C8.33642 11.8479 8.78656 12.2345 9.44851 12.3024V10.3593L8.89247 10.2287C7.62151 9.93616 6.93836 9.21532 6.93836 8.12362C6.93836 6.83865 7.8704 6.01335 9.44851 5.88799V5.1776H10.1899V5.88799C11.6621 6.0238 12.6153 6.87522 12.6365 8.08183H11.159C11.1431 7.6065 10.746 7.21474 10.1899 7.13639V8.99594L10.7565 9.11085C12.1175 9.39814 12.7848 10.0929 12.7848 11.2211C12.7848 12.5531 11.8475 13.3784 10.1899 13.5142ZM8.47411 7.97737C8.47411 8.41613 8.80774 8.71909 9.44851 8.84446V7.13117C8.87658 7.16251 8.47411 7.51248 8.47411 7.97737ZM10.1899 10.4898C10.9313 10.6257 11.2808 10.9182 11.2808 11.3987C11.2808 11.9263 10.8783 12.2658 10.1899 12.3076V10.4898Z",
  clipRule: "evenodd"
});

function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.c2c46521.svg";
export { ForwardRef as ReactComponent };